export const NAV_LINKS = [];

export const HERO = {
  overline: "Precise location-driven social",
  lines: ["Social Media", "For Places"],
  body: "Every post leads to a real place.",
  bodySub:
    "eurikaa makes those places easy to find with exact locations, operating hours, and one-tap directions.",
};

export const MARQUEE_ITEMS = [
  "Precision Discovery",
  "3-Meter Accuracy",
  "Never Guess Again",
  "Real Places, Real People",
];

export const CHAPTERS = [
  {
    num: "01",
    icon: "MapPin",
    title: "Pinpoint Navigation",
    subtitle: "Guide customers directly to you",
    body:
      "Stop losing customers to the scroll. eurikaa provides ultra-precise directions, within 3 meters, straight to your physical stand. That means more foot traffic, more sales, and less time wasted explaining where you are. Get customers to your stand, not just your feed.",
    stat: "3m",
    statLabel: "Directional accuracy",
  },
  {
    num: "02",
    icon: "Radar",
    title: "Local Discovery",
    subtitle: "Reach new customers near you",
    body:
      "Expand your reach far beyond your current followers. eurikaa automatically broadcasts your posts to every potential customer within a 10-mile radius, even people who haven't discovered you yet. Local discovery puts your stand in front of thousands of new eyes.",
    stat: "10mi",
    statLabel: "Discovery radius",
  },
  {
    num: "03",
    icon: "Clock",
    title: "Real-Time Availability",
    subtitle: "Customers always know when to find you",
    body:
      "Never miss a customer to outdated information again. Instantly publish and update your hours, special events, and availability in real time. Your customers always know exactly when and where to find you, driving satisfaction and consistent business.",
    stat: "Live",
    statLabel: "Always current",
  },
  {
    num: "04",
    icon: "Share2",
    title: "Unified Social Sharing",
    subtitle: "Post once, reach everywhere",
    body:
      "Stop the multi-platform juggling act. With integrated social sharing, you post once and eurikaa automatically shares it across your connected accounts. Keep your entire audience in the loop effortlessly, everywhere they are.",
    stat: "1x",
    statLabel: "Post once, sync all",
  },
];

export const BENTO = [
  {
    icon: "LayoutGrid",
    title: "Self-Curated Home Screen",
    body: "Filter your world by Interests, Near Me, People, and Location.",
  },
  {
    icon: "CalendarClock",
    title: "Events",
    body: "Discover and share time-sensitive places the moment they matter.",
  },
  {
    icon: "Users",
    title: "Groups",
    body: "Connect with others who share your passions and places.",
  },
  {
    icon: "Sparkles",
    title: "AI-Powered Enhancements",
    body: "Improve your stories and images with a single tap.",
  },
  {
    icon: "Send",
    title: "Cross-Platform Sharing",
    body: "Easily share your eurikaa posts anywhere you go.",
  },
  {
    icon: "WifiOff",
    title: "Offline Posting",
    body: "Share your adventures even when the connection drops.",
  },
];

export const STORIES = [
  {
    id: "vendors",
    overline: "For mobile vendors",
    title: "Designed for Mobile Vendors",
    body:
      "Food trucks, coffee carts, market stalls, pop-up shops, street performers: eurikaa was made with you in mind. Instead of fighting algorithms or hoping hashtags work, you simply post your location and get discovered by nearby customers. Mobile vendors finally get the visibility they deserve and the foot traffic they need.",
    image: "/assets/farmersmarket.png",
    imageAlt: "eurikaa feed showing nearby market events",
    align: "left",
  },
  {
    id: "customers",
    overline: "For every explorer",
    title: "Turn Posts Into Customers",
    body:
      "eurikaa transforms every post into a destination. Customers don't just see what you're offering, they see exactly where to find you. With real-time location updates and precise maps, your followers can walk right up to your stand. Less confusion, more sales, and a stronger connection to your community.",
    image: "/assets/customers.png",
    imageAlt: "A vendor handing food to a happy customer",
    align: "right",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    quote:
      "eurikaa has transformed how I discover local gems. As a mobile vendor, finding new spots to set up has never been easier. Highly recommend!",
    author: "Maria S.",
    title: "Mobile Vendor",
  },
  {
    id: 2,
    quote:
      "As a travel influencer, authentic experiences are key. eurikaa connects me with unique, location-based adventures that truly stand out.",
    author: "David L.",
    title: "Travel Influencer",
  },
  {
    id: 3,
    quote:
      "I love exploring new places, and eurikaa makes it so simple to find hidden treasures around me. It's my go-to app for local discovery.",
    author: "Sarah J.",
    title: "Everyday Explorer",
  },
  {
    id: 4,
    quote:
      "The community aspect of eurikaa is fantastic. It's more than just an app, it's a way to connect with others who love to explore.",
    author: "Omar K.",
    title: "Community Member",
  },
];

export const FOUNDERS = [
  { name: "Timothy Hill", role: "CEO" },
  { name: "Shawn Branstetter", role: "CPO" },
  { name: "Randa Fahmy", role: "CTO" },
];

export const ASSETS = {
  logoDark: "/assets/eurikaa-horizontal-dark.png",
  logoLight: "/assets/eurikaa-main-light.png",
  heroImage: "/assets/hero-image.png",
  heroCollage: "/assets/hero-collage.png",
  discover: "/assets/discover.png",
  mobile: "/assets/mobile.png",
  peopleGroup: "/assets/people-group.png",
  appStore: "/assets/app-store-badge.svg",
  googlePlay: "/assets/google-play-badge.png",
};

export const APP_STORE_URL =
  "https://apps.apple.com/es/app/eurikaa/id6759992313?l=en-GB";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.eurikaa.app&pcampaignid=web_share";
